import { Form } from '@anytag/shared-atoms';
import { useUpdateYoutubeAssetChannelId } from '../hooks';
import { YoutubeCMSAssetOwnerChannelIdFormValues } from './types';
import { Template, TemplateProps } from './template';

export type YoutubeCMSAssetsListProps = TemplateProps;

export const YoutubeCMSAssetsList = (props: YoutubeCMSAssetsListProps) => {
  const { handleSaveChange } = useUpdateYoutubeAssetChannelId();

  return (
    <Form.Provider
      onSubmit={handleSaveChange}
      values={props.data?.reduce<YoutubeCMSAssetOwnerChannelIdFormValues>(
        (acc, { id, ownerChannelId }) => (id ? { ...acc, [`${id}-ownerChannelId`]: ownerChannelId || '' } : acc),
        {}
      )}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent form submit on Enter key, user needs to click the Save button
        }
      }}
    >
      <Template {...props} />
    </Form.Provider>
  );
};

export * from './types';
